(function($) {
    $.widget("ca.caTimeRange", {
        options: {
            startTime : '9:00:00',
            endTime : '21:00:00',
            timeInterval : 15,
            countCells : 0,
            cellWidth : 0,
            workTime : {}
        },
        _create : function() {
            var self = this;
            var options = this.options;

            var startTimeParts = options.startTime.split(':');
            options.startTime = new Date();
            options.startTime.setHours(startTimeParts[0]);
            options.startTime.setMinutes(startTimeParts[1]);
            options.startTime.setSeconds(0);
            options.startTime.setMilliseconds(0);

            var endTimeParts = options.endTime.split(':');
            options.endTime = new Date();
            options.endTime.setHours(endTimeParts[0]);
            options.endTime.setMinutes(endTimeParts[1]);
            options.endTime.setSeconds(0);
            options.endTime.setMilliseconds(0);

            if (options.startTime.getTime() >= options.endTime.getTime()) {
                options.endTime.addDays(1);
            }

            this._initSelectable();
        },
        _initSelectable : function() {
            var self = this;
            var options = self.options;

            var blocksContainer = self.element.find('.blocks-container');
            var cellHeight = blocksContainer.height();

            var selectableBlock = $('<div class="selectable-block"></div>').appendTo(blocksContainer);
            selectableBlock.width(options.countCells * options.cellWidth);
            selectableBlock.height(cellHeight);

            var cell = $('<div class="cell"></div>');
            cell.width(options.cellWidth);
            cell.height(cellHeight);

            for (var i = 0; i < options.countCells; i++) {
                cell.clone().appendTo(selectableBlock);
            }

            var cells = selectableBlock.find('.cell');
            var cellIndex = 0;
            for (var i in options.workTime) {
                if (options.workTime[i] === true) {
                    cells.eq(cellIndex).addClass('free-time');
                }
                cellIndex++;
            }

            selectableBlock.selectable({
                filter : '.free-time, .ui-selected',
                start : function(event, ui) {
                },
                stop : function(event, ui) {
                    var selectedCells = selectableBlock.find('.ui-selected');
                    if (selectedCells.size() == 0) {
                        self.element.find('.start-time').val('');
                        self.element.find('.end-time').val('');
                        return false;
                    }

                    var startCell = selectedCells.eq(0);
                    var startCellIndex = startCell.index();
                    var startTime = self._getTimeByCellIndex(startCellIndex);
                    var endTime = self._getTimeByCellIndex(startCellIndex + 1);

                    var hasEndTime = false;
                    $.each(selectedCells, function() {
                        var cell = $(this);
                        if(hasEndTime) {
                            cell.removeClass('ui-selected');
                        } else if (!cell.next().hasClass('ui-selected')) {
                            endTime = self._getTimeByCellIndex(cell.index() + 1);
                            hasEndTime = true;
                        }
                    });

                    self.element.find('.start-time').val(startTime.getHours() + ':' + (startTime.getMinutes() > 0 ? startTime.getMinutes() : '00') + ':' + (startTime.getSeconds() > 0 ? startTime.getSeconds() : '00'));
                    self.element.find('.end-time').val(endTime.getHours() + ':' + (endTime.getMinutes() > 0 ? endTime.getMinutes() : '00') + ':' + (endTime.getSeconds() > 0 ? endTime.getSeconds() : '00'));

                    self._trigger('onSelectTime', event, {startTime : startTime, endTime : endTime});
                }
            });

            var startTimeHidden = self.element.find('.start-time');
            var endTimeHidden = self.element.find('.end-time');
            if (startTimeHidden.val().length != 0 && endTimeHidden.val().length != 0) {
                var startTime = new Date();
                var startTimeParts = startTimeHidden.val().split(':');
                startTime.setHours(startTimeParts[0]);
                startTime.setMinutes(startTimeParts[1]);
                startTime.setSeconds(0);
                startTime.setMilliseconds(0);

                var endTime = new Date();
                var endTimeParts = endTimeHidden.val().split(':');
                endTime.setHours(endTimeParts[0]);
                endTime.setMinutes(endTimeParts[1]);
                endTime.setSeconds(0);
                endTime.setMilliseconds(0);

                var startCellIndex = self._getCellIndexByTime(startTime);
                var endCellIndex = self._getCellIndexByTime(endTime) - 1;

                var selectedCells = selectableBlock.find('.cell').not(':gt('+ endCellIndex +')').not(':lt('+ startCellIndex +')');
                selectedCells.addClass('ui-selected');

                $('.selectable-block .cell').on('click', function(){
                    if(!$(this).hasClass('free-time')){
                        self._trigger(
                            'onMouseClick',
                            { startTime : $('#visit_time-startTime').val(), endTime : $('#visit_time-endTime').val() }
                        );
                    }
                });
            }
        },

        _getTimeByCellIndex : function(cellIndex) {
            var options = this.options;

            return new Date(options.startTime.getTime() + options.timeInterval * cellIndex * 60000);
        },

        _getCellIndexByTime : function(time) {
            var options = this.options;

            return parseInt((time.getTime() - options.startTime.getTime()) / 60000 /  options.timeInterval);
        }
    });
})(jQuery);